import { useNavigate } from 'react-router-dom';
import logo from '../media/Balanz_white_logo.svg';

export const SuccessAccount = () => {
    const history = useNavigate();

  const loginRedirect = () => {
    history('/');
  };

    return (
        <div className='columns w-row container-log-check'>
            <div className='logocolumn w-col w-col-4 w-col-stack'>
                <img
                    src={logo}
                    loading='lazy'
                    alt='Balanz logo'
                    width='600'
                    sizes='(max-width: 479px) 63vw, (max-width: 767px) 43vw, (max-width: 991px) 36vw, 23vw'
                    className='loginlogo'
                />
            </div>
            <div className='formcolumn w-col w-col-8 w-col-stack'>
                <div className='form-info'>
                    <h4 className='h2-titles' style={{ textAlign: "center" }}>Welcome</h4>
                    <p className='paragraph'>You have successfully set up your credentials.</p>
                    <p className='paragraph'>Click below to go back to the login page so you can sign in using your new credentials.</p>
                    <input type='submit' data-wait='' value='Continue' className='button continue w-button' onClick={loginRedirect} />
                </div>
            </div>
        </div>
    );
};
